export default __webpack_public_path__ + "static/media/logo_buyuk_beyaz.a3649363.png";